import React, { useEffect } from 'react';
import Message from '../../components/message/Message';
import { SegmentProps } from '../../state-machine/actions/segment';
type ErrorsFoundProps = SegmentProps & {
  body: string;
  buttonText: string;
  lowerHeading?: string;
  buttonBehavior(): void;
  header?: string;
  //Todo: Remove these props once detailed debit soft declines feature is fully rolled out
  segmentPageName?: string;
  segmentTrackName?: string;
  decisionCode?: string;
};

const ErrorsFound: React.FC<ErrorsFoundProps> = (props) => {
  useEffect(() => {
    //Todo: Remove this logic once detailed debit soft declines feature is fully rolled out
    props.page(props.segmentPageName ? props.segmentPageName : 'Errors Found');
    props.segmentTrackName && props.track(props.segmentTrackName, props.decisionCode ? { decisionCode: props.decisionCode } : {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Message
      heading={props.header || 'Hmm...'}
      lowerHeading={props.lowerHeading}
      body={props.body}
      buttonText={props.buttonText}
      buttonClick={props.buttonBehavior}
    />
  );
};

export default ErrorsFound;
